import { ErrorResponseErrorItemCodeGeodata } from '../../../../typings/api/skymap/rest/v1/.common';

export const translations: Record<ErrorResponseErrorItemCodeGeodata, string> = {
  'geodata:not_found': 'Molnprocesseringen kunde inte hittas.',
  'geodata:user_unauthorized': 'Du har inte åtkomst till molnprocesseringen.',
  'geodata:not_ready_for_gcp': 'Molnprocesseringen är inte redo för flaggflyttning.',
  'geodata:not_idle':
    'Molnprocesseringen pågår. Vänta till molnprocesseringen är klar och försök sedan igen.',
  'geodata:coordinate_system_not_found': 'Molnprocesseringen saknar koordinatsystem.',
  'geodata:filtered_point_cloud_not_found': 'Det filtrerade punktmolnet kunde inte hittas.',
  'geodata:tiled_model_not_found': 'Cesium 3D-modellen kunde inte hittas.',
  'geodata:has_volume_calculations':
    'Det finns volymberäkningar kopplade till molnprocesseringens punktmoln. Ta bort dessa och fösök igen.',
  'geodata:connected_to_timeline':
    'Molnprocesseringen är kopplad till minst en tidslinje. Koppla bort molnprocesseringens avbildning, ortofoto samt punktmoln från berörda tidslinjer och försök sedan igen.',
};
